export default {
    'cn': {
        i18n: {
            breadcrumb: '小之物联',
            items: [
              {
                icon: "el-icon-lx-home",
                index: "homepage",
                title: "首页"
              },
              {
                icon: "el-icon-lx-copy",
                index: "table2",
                title: "新闻资讯"
              },
              {
                icon: "el-icon-lx-copy",
                index: "InternetofThings",
                title: "产品中心"
              },
              {
                icon: "el-icon-lx-copy",
                index: "Solution",
                title: "解决方案"
              },
              {
                icon: "el-icon-lx-copy",
                index: "cases",
                title: "关键产品"
              },
              {
                icon:"el-icon-lx-rank",
                index:"downloadCenter",
                title:"服务与支持"
              },
              {
                icon: "el-icon-lx-rank",
                index: "JoinUs",
                title: "加入小之"
              },
              {
                icon: "el-icon-lx-rank",
                index: "administration",
                title: "系统管理",
              },
            ],
        }
    },
    'en': {
        i18n: {
            breadcrumb: 'Smart campus management system',
            items: [
              {
                icon: "el-icon-lx-home",
                index: "statistics",
                title: "statistical analysis",
                subs: [
                  {
                    icon: "el-icon-lx-copy",
                    index: "homepage",
                    title: "home",
                  },
                  {
                    icon: "el-icon-lx-copy",
                    index: "dashboard",
                    title: "Dormitory management",
                  },
                  {
                    icon: "el-icon-lx-copy",
                    index: "studentsRoom",
                    title: "Classroom management",
                  },
                ],
              },
              {
                icon: "el-icon-lx-copy",
                index: "business",
                title: "Business management",
                subs: [
                  {
                    icon: "el-icon-lx-copy",
                    index: "RoomInquiry",
                    title: "Accommodation business",
                    subs: [
                      {
                        index: "CheckIn",
                        title: "Check in",
                      },
                      {
                        index: "dueRoom",
                        title: "Room inquiry",
                      },
                      {
                        index: "Refund",
                        title: "Exit management",
                      },
                    ],
                  },
                  {
                    icon: "el-icon-lx-calendar",
                    index: "dueRoom",
                    title: "Teaching business",
                  },
                  {
                    icon: "el-icon-lx-calendar",
                    index: "CheckInStaff",
                    title: "Extracurricular activities",
                  },
                  {
                    icon: "el-icon-lx-calendar",
                    index: "CheckInStaff",
                    title: "Warranty service",
                  },
                ],
              },
              {
                icon: "el-icon-lx-copy",
                index: "fygl",
                title: "Housing supply management",
                subs: [
                  {
                    index: "room",
                    title: "Student dormitory",
                  },
                  {
                    index: "campus",
                    title: "Office building?",
                  },
                  {
                    index: "campus",
                    title: "Academic Building",
                  },
                ],
              },
              {
                icon: "el-icon-lx-copy",
                index: "rygl",
                title: "Personnel management",
                subs: [
                  {
                    index: "userManagement",
                    title: "Student information",
                  },
                  {
                    index: "voucher",
                    title: "Teacher information",
                  },
                  {
                    index: "userManagement",
                    title: "Property information",
                  },
                ],
              },
              {
                icon: "el-icon-lx-copy",
                index: "tabs",
                title: "device management",
                subs: [
                  {
                    icon: "el-icon-lx-copy",
                    index: "doorLock",
                    title: "Door lock equipment",
                  },
                  {
                    icon: "el-icon-lx-copy",
                    index: "table1",
                    title: "Air switch equipment",
                  },
                  {
                    icon: "el-icon-lx-copy",
                    index: "table1",
                    title: "Smoke sensing equipment",
                  },
                ],
              },
              {
                icon: "el-icon-lx-rank",
                index: "7",
                title: "system management",
                subs: [
                  {
                    index: "upload",
                    title: "Manage logo",
                  },
                ],
              },
              {
                icon: "el-icon-rank",
                index: "6",
                title: "user management",
                subs: [
                  {
                    index: "loginAccount",
                    title: "Login account",
                  },
                  {
                    index: "rolePermissions",
                    title: "Role permissions",
                  },
                  {
                    index: "bindingRoles",
                    title: "Binding roles",
                  },
                ],
              },
              {
                icon: "el-icon-lx-rank",
                index: "permission",
                title: "Log management",
              },
            ],
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/i18n.js